import React from 'react';
import './detailBoxEmployee.css';
import { iconMapping } from '../../../../utils/icons';



const DetailBoxEmployee = ({ title, data, id }) => {
  if (!data || typeof data !== 'object') {
    return null;
  }

  const toSnakeCase = (key) => {
    return key
      .replace(/([A-Z])/g, '_$1') 
      .replace(/^_/, '') 
      .toLowerCase(); 
  };

  const formatKey = (key) => {
    return key
      .replace(/([A-Z])/g, ' $1') 
      .replace(/^./, (str) => str.toUpperCase()); 
  };

  return (
    <div className="detail-box-employee__detail-box" id={id}>
      <h3>{title}</h3>
      <ul>
        {Object.entries(data).map(([key, value]) => {
          const snakeKey = toSnakeCase(key); 
          const Icon = iconMapping[snakeKey] || iconMapping['default']; 

          return (
            <li key={key} className="detail-box-employee__icon-info-container">
              <div className="detail-box-employee__icon-container">
                {Icon}
              </div>
              <div className="detail-box-employee__icon-label-container">
                <strong>{formatKey(key)}</strong>:
                <p>{value}</p>
              </div>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default DetailBoxEmployee;
